import { render, staticRenderFns } from "./Event.vue?vue&type=template&id=d623faae&scoped=true"
import script from "./Event.vue?vue&type=script&lang=ts"
export * from "./Event.vue?vue&type=script&lang=ts"
import style0 from "./Event.vue?vue&type=style&index=0&id=d623faae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d623faae",
  null
  
)

export default component.exports